import { useEffect, useState } from "react";
import Menu from "../../../../components/Menu/Menu";
import NotAuthenticated from "../../../../components/NotAuthenticated/NotAuthenticated";
import useAuth from "../../../../hooks/useAuth";
import api from "../../../../js/api";
import './PartyFun.scss';
import Button from "../../../../components/Button/Button";

export default function PartyFun() {

    const [room, setRoom] = useState('');
    const [game_data, setGame_data] = useState(null);

    useEffect(() => {
        const fetch_ = async () => {
            try {
                const response = await api.get(`/games/partyfun`);
                setGame_data(response);
                console.log(response);
            } catch (error) {
                console.error(error);
            }
        }
        fetch_();
    }, [])

    const loadGameData = () => {
        if (!game_data)
            return <p>Loading...</p>;

        if (game_data.error) {
            console.error(game_data.error);
            return null;
        }

        return (
            game_data ? (
                game_data && !game_data.error ? (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        {
                            Object.keys(game_data).map((key, index) => (
                                game_data[key] ?
                                    <p key={index}><b>{key}</b>: {game_data[key]}</p>
                                    :
                                    ''
                            ))
                        }
                    </div>
                ) : (
                    null
                )
            ) : (
                <p>Loading...</p>
            )
        )
    }


    const authenticated = useAuth();
    if (authenticated === false)
        return <NotAuthenticated />;

    return (
        <div id='party-fun'>
            <div className='centered-container'>
                <h1 className="title">PartyFun</h1>
                <Button text={"Create Room"} onClick={(e) => {
                    console.log('Create Room');
                }} />
                <input type="number" className='partyfun-input' onChange={(e) => {
                    setRoom(e.target.value);
                }} />
                <Button text="Join Room" onClick={(e) => {
                    if (room == '') {
                        alert('Please enter a room number');
                        return;
                    }
                    console.log(`Join Room ${room}`);
                }} />
                <br />
                <br />
                {loadGameData()}

                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    )
}